import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const navLinks = [
	{ label: 'Home', hash: 'home' },
	{ label: 'Services', hash: 'services' },
	{ label: 'About', hash: 'about' },
	{ label: 'Contact', hash: 'contact' },
];

function Header() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const { pathname } = useLocation();
	const isHome = pathname === '/';

	const getHref = (hash) => (isHome ? `#${hash}` : `/#${hash}`);

	const handleMenuToggle = () => {
		setIsMenuOpen((prev) => !prev);
	};

	const handleNavClick = () => {
		setIsMenuOpen(false);
	};

	return (
		<>
			<header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 shadow-sm backdrop-blur-md">
				<div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
					<a href={getHref('home')} className="flex items-center gap-3" onClick={handleNavClick}>
						<div className="flex h-11 w-11 items-center justify-center rounded-xl bg-slate-900 text-xl font-extrabold text-cyan-300 shadow-md transition-transform duration-300 hover:scale-105">
						V
					</div>
					<div>
							<p className="text-xl font-extrabold tracking-tight text-slate-900 sm:text-2xl">Viance Healthcare Systems</p>
							<p className="text-xs text-slate-500">Private Limited • Digital Solutions</p>
					</div>
				</a>

					<nav className="hidden items-center gap-2 md:flex" aria-label="Main navigation">
					{navLinks.map((link) => (
						<a
							key={link.label}
							href={getHref(link.hash)}
							className="rounded-full px-4 py-2 text-sm font-medium text-slate-700 transition-all duration-300 hover:bg-slate-100 hover:text-cyan-700"
						>
							{link.label}
						</a>
					))}
					</nav>

					<button
					type="button"
					onClick={handleMenuToggle}
					className="inline-flex items-center justify-center rounded-xl border border-slate-200 p-2.5 text-slate-700 transition duration-300 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-cyan-600/30 md:hidden"
					aria-expanded={isMenuOpen}
					aria-label="Toggle navigation menu"
				>
						<svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						{isMenuOpen ? (
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
						) : (
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
						)}
						</svg>
					</button>
				</div>
			</header>

			<div
				className={`fixed inset-0 z-40 bg-slate-950/40 transition-opacity duration-300 md:hidden ${
					isMenuOpen ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
				}`}
				onClick={handleNavClick}
				aria-hidden={!isMenuOpen}
			/>

			<nav
				className={`fixed right-0 top-0 z-50 h-full w-72 max-w-[85vw] bg-white px-6 py-6 shadow-2xl transition-transform duration-300 md:hidden ${
					isMenuOpen ? 'translate-x-0' : 'translate-x-full'
				}`}
				aria-label="Mobile navigation"
			>
				<div className="mb-8 flex items-center justify-between border-b border-slate-200 pb-4">
					<div>
						<p className="text-lg font-extrabold text-slate-900">Viance Healthcare Systems</p>
						<p className="text-xs text-slate-500">Navigation</p>
					</div>
					<button
						type="button"
						onClick={handleNavClick}
						className="rounded-lg p-2 text-slate-700 transition hover:bg-slate-100"
						aria-label="Close navigation menu"
					>
						<svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</button>
				</div>

				<div className="flex flex-col gap-2">
					{navLinks.map((link) => (
						<a
							key={link.label}
							href={getHref(link.hash)}
							onClick={handleNavClick}
							className="rounded-xl px-4 py-3 text-base font-medium text-slate-700 transition-all duration-300 hover:bg-slate-100 hover:text-cyan-700"
						>
							{link.label}
						</a>
					))}
				</div>
			</nav>
		</>
	);
}

export default Header;
